<svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="12.0586" cy="12.0588" r="7.06194" stroke="#A6ABB6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M21.0033 21.0034L17.0517 17.0518" stroke="#A6ABB6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
